import useSWR from "swr";

export function useChainlinkDesigns() {
  const { data, error, isLoading, mutate } = useSWR(`/team/designs/chainlink`);

  return {
    chainlinkDesigns: data,
    isLoading,
    error,
    mutate,
  };
}
